// src/components/SignOutButton.jsx
import { signOut, fetchAuthSession } from "aws-amplify/auth";

// XXX should this be baked in at build time?
const COGNITO_DOMAIN = "us-east-2siqkwhilx.auth.us-east-2.amazoncognito.com"; // hostname only
const CLIENT_ID = "56nmou8h44r5fjkcjtmea1vbcl";                         // SPA client id

const ORIGIN = window.location.origin;  // http://localhost:3000 or https://d1hwiskbgrliqb.cloudfront.net
const LOGOUT_REDIRECT = `${ORIGIN}/signed-out`;

export default function SignOutButton() {
  async function handleClick() {
    try {
      await signOut({ global: true });

      try {
        const session = await fetchAuthSession();
        const refresh = session.tokens?.refreshToken?.toString();
        if (refresh) {
          await fetch(`https://${COGNITO_DOMAIN}/oauth2/revoke`, {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: new URLSearchParams({ token: refresh, client_id: CLIENT_ID }),
          });
        }
      } catch { /* ignore */ }

      localStorage.removeItem("amplify-signin-with-hostedUI");
      Object.keys(localStorage)
        .filter(k => k.includes("CognitoIdentityServiceProvider"))
        .forEach(k => localStorage.removeItem(k));

      const logoutUri = encodeURIComponent(LOGOUT_REDIRECT);
      window.location.assign(
        `https://${COGNITO_DOMAIN}/logout?client_id=${CLIENT_ID}&logout_uri=${logoutUri}`
      );
    } catch (e) {
      const logoutUri = encodeURIComponent(LOGOUT_REDIRECT);
      window.location.assign(
        `https://${COGNITO_DOMAIN}/logout?client_id=${CLIENT_ID}&logout_uri=${logoutUri}`
      );
    }
  }



  return (
    <button
      onClick={handleClick}
      className="inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium text-purple-700 hover:text-purple-900 hover:bg-purple-50 transition-colors"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-4 w-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.5}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6A2.25 2.25 0 005.25 5.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"
        />
      </svg>
      Sign Out
    </button>


  );
}
